// @flow strict
import * as React from 'react';
import type {CustomFormField} from 'src/types/crm';
import classify from 'src/utils/classify';
import {Input} from '@spaced-out/ui-design-system/lib/components/Input';
import {Textarea} from '@spaced-out/ui-design-system/lib/components/Textarea';
import css from './index.css';

// $FlowFixMe[unclear-type] - Using any type to avoid complex component compatibility issues
type FormikFieldType = any;

type InputFieldPropsType = {
  field: CustomFormField,
  formikField: FormikFieldType,
  error: ?mixed,
  touched: boolean,
  isRequired: boolean,
  onChange: (string, mixed) => void,
  type?: string,
  label?: string,
  classNames?: string,
  value?: string,
};

export const InputField = (props: InputFieldPropsType): React.Node => {
  const {
    field,
    type = 'text',
    formikField,
    error,
    touched,
    isRequired,
    onChange,
    classNames,
    label,
    value,
  } = props;
  const hasError = Boolean(error && touched);

  return (
    <div className={classify(css.inputContainer, classNames)}>
      <Input
        {...formikField}
        placeholder={field.customField.placeholder}
        error={hasError}
        errorText={error || ''}
        required={isRequired}
        label={label}
        type={type}
        onChange={(e) => onChange(formikField.name, e.target.value)}
        value={value || formikField.value || ''}
      />
    </div>
  );
};

export const TextAreaField = ({
  field,
  formikField,
  isRequired,
  onChange,
  touched,
  error,
  classNames,
  value,
}: InputFieldPropsType): React.Node => {
  const hasError = Boolean(error && touched);

  return (
    <div className={classify(css.inputTextAreaContainer, classNames)}>
      <Textarea
        {...formikField}
        placeholder={field.customField.placeholder}
        className={css.textareaField}
        error={hasError}
        errorText={error || ''}
        required={isRequired}
        label={field.questionTag}
        onChange={(e) => onChange(formikField.name, e.target.value)}
        value={value || formikField.value || ''}
      />
    </div>
  );
};
